'use client';

import { c as _c } from "react/compiler-runtime";
import { Popover as PopoverPrimitive } from 'radix-ui';
import { tv } from 'tailwind-variants';
function Popover(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <PopoverPrimitive.Root data-slot="popover" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function PopoverTrigger(t0) {
  const $ = _c(6);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  const t1 = `group ${className ?? ""}`;
  let t2;
  if ($[3] !== props || $[4] !== t1) {
    t2 = <PopoverPrimitive.Trigger className={t1} data-slot="popover-trigger" {...props} />;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
const popover = tv({
  base: `
    animate-out
    fade-out
    data-[state=open]:animate-in
    data-[state=open]:fade-in
    bg-background
    z-50
    origin-(--radix-popover-content-transform-origin)
    rounded-md
    border
    p-4
    shadow-md
    outline-hidden
    will-change-[transform,opacity]
    w-[var(--radix-popover-trigger-width)]
  `,
  variants: {
    side: {
      bottom: `
        slide-out-to-bottom-1
        data-[state=open]:slide-in-from-bottom-1
      `,
      left: `
        slide-out-to-right-1
        data-[state=open]:slide-in-from-right-1
      `,
      right: `
        slide-out-to-left-1
        data-[state=open]:slide-in-from-left-1
      `,
      top: `
        slide-out-to-bottom-1
        data-[state=open]:slide-in-from-bottom-1
      `
    }
  },
  defaultVariants: {
    side: 'bottom'
  }
});
function PopoverContent(t0) {
  const $ = _c(16);
  let className;
  let props;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      className,
      align: t1,
      sideOffset: t2,
      disablePortal: t3,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const align = t1 === undefined ? "center" : t1;
  const sideOffset = t2 === undefined ? 4 : t2;
  const disablePortal = t3 === undefined ? false : t3;
  let t4;
  if ($[6] !== className) {
    t4 = popover({
      className
    });
    $[6] = className;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== align || $[9] !== props || $[10] !== sideOffset || $[11] !== t4) {
    t5 = <PopoverPrimitive.Content className={t4} align={align} data-slot="popover-content" sideOffset={sideOffset} {...props} />;
    $[8] = align;
    $[9] = props;
    $[10] = sideOffset;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const content = t5;
  let t6;
  if ($[13] !== content || $[14] !== disablePortal) {
    t6 = disablePortal ? content : <PopoverPrimitive.Portal>{content}</PopoverPrimitive.Portal>;
    $[13] = content;
    $[14] = disablePortal;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}
function PopoverAnchor(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <PopoverPrimitive.Anchor data-slot="popover-anchor" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
export { Popover, PopoverTrigger, PopoverContent, PopoverAnchor };